import React, {useState, useEffect} from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  Navigation,
  Footer,
} from "./components";
import Home from './pages/Home';
import ToolsPage from './pages/Tools';
import WebsitesPage from './pages/Websites';
import './index.scss';
import './i18n';

function App() {
    const [mode, setMode] = useState<string>('dark');

    const handleModeChange = () => {
        if (mode === 'dark') {
            setMode('light');
        } else {
            setMode('dark');
        }
    }

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);

    return (
    <div className={`main-container ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
        <BrowserRouter>
            <Navigation parentToChild={{mode}} modeChange={handleModeChange}/>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/websites" element={<WebsitesPage />} />
                <Route path="/tools" element={<ToolsPage />} />
            </Routes>
        </BrowserRouter>
        <Footer />
    </div>
    );
}

export default App;